import * as React from 'react';
import { updatePurchaseType } from '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import 'classnames';
import '@grandvisionhq/forms';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '../../../../../types/product.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/elements';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/common';
import '../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '../../../../../hooks/use-product-view-history.js';
import { PurchaseTypeSelectionBoxes } from '../../../components/PurchaseTypeSelectionBoxes/PurchaseTypeSelectionBoxes.js';
import '../../../../../slots/context.js';
import '@grandvisionhq/content';
import '../../types/quantity-discounts.js';
import { useCLEcommContext } from '../../context/CLEcommContext.js';

const CLPurchaseTypeSelectionBoxes = ({ className  })=>{
    const { activeVariant: { purchaseTypePrices , isAvailableForSubscription  } , dispatch ,  } = useProductData();
    const { actions: actions$1 , state  } = useCLEcommContext();
    const { purchaseType  } = state.configurations;
    const handleSelection = React.useCallback((key)=>{
        actions$1.updatePurchaseType(key);
        dispatch(updatePurchaseType({
            purchaseType: key
        }));
    }, [
        actions$1
    ]);
    return /*#__PURE__*/ React.createElement(PurchaseTypeSelectionBoxes, {
        className: className,
        selectedPurchaseType: purchaseType,
        subscriptionTypeAllowed: isAvailableForSubscription,
        purchaseTypePrices: purchaseTypePrices,
        onSelection: handleSelection
    });
};

export { CLPurchaseTypeSelectionBoxes };
//# sourceMappingURL=CLPurchaseTypeSelectionBoxes.js.map
